import React, { useEffect, useState } from "react";
import { 
    Box,
    Flex,
    Link,
} from "@chakra-ui/react";
import type { SnackbarType } from "../types/homePageTypes";

// A bar fixed at the bottom of the screen generally used for promotional campaigns

const Snackbar: React.FC<SnackbarType> = ({
    active,
    backgroundColor,
    headline,
    headlineButtonColor,
    copy,
    copyColor,
    buttonCopy,
    buttonLink,
    showButton,
}) => {

    if (!active) return null;

    /* --- Click handler and google analytics --- */
	useEffect(() => {
		// add google analytics to snackbar
        const script = document.createElement('script');
        script.text = `$("#film-snackbar-donate").click(() => { ga("send", "event", "Snackbar", "click", "snackbar-button-clicked") }); $("#film-snackbar-close").click(() => { ga("send", "event", "Snackbar", "click", "close") });`;
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

	return (
        <Box
            className="container-fluid show"
            position="relative"
            bgColor={ backgroundColor ? `#${ backgroundColor }` : "#E80000" }
            p="0"
        >
            <Flex
                className="row"
                height="100%"
                alignItems="center"
                justifyContent="space-between"
                textAlign="center"
                paddingTop={{ base: "2px", sm: "0px", xl: "16px" }}
                paddingBottom={{ base: "10px", sm: "30px", xl: "16px" }}
            >
                <Box className="col-8 col-sm-12 col-xl-6 p-0">
                    <Box
                        className="mega"
                        m={{ base: "16px 0px 4px 20px", sm: "29px 0px 8px 40px", xl: "11px 5px 16px 40px"}}
                        color={`#${ headlineButtonColor }`}
                        textAlign="left"
                        fontSize={{ base: "25px", sm: "48px" }}
                        lineHeight={{ base: "30px", sm: "56px" }}
                        letterSpacing={{ base: "-0.5px", sm: "-1.4px", xl: "-1.75px" }}
                    >
                        { headline }
                    </Box>
                </Box>
                <Box className="col-9 col-xl-4 p-0">
                    <Box
                        className="bravo"
                        m={{ base: "0px 14px 6px 20px", sm: "0px 27px 6px 40px", xl: "0px" }}
                        color={ copyColor ? `#${copyColor}` : "#FFFFFF" }
                        fontSize={{ base: "12px", sm: "22px" }}
                        lineHeight= {{ base: "16px", sm: "26px", xl: "24px" }}
                        letterSpacing="0px"
                    >
                        { copy }
                    </Box>
                </Box>
                {showButton &&
                    <Box className="col-3 col-xl-2 p-0">
                        <Link
                            href={ buttonLink } 
                            target="_blank"
                            textDecoration="underline"
                        >
                            <Box
                                id="film-snackbar-donate" 
                                p={{ base: "9px 11px", sm: "15px 17px" }}
                                m={{ base: "4px 20px 12px auto", sm: "6px 40px 20px auto", xl: "23px 40px 23px auto" }}
                                fontFamily="Libre Franklin, sans-serif"
                                fontWeight="700"
                                fontSize={{ base: "12px", sm: "18px" }}
                                lineHeight={{ base: "12px", sm: "18px" }}
                                letterSpacing={{ base: "-0.06px", sm: "-0.09px" }}
                                background="#000"
                                color="#fff"
                                border="2px solid transparent"
                                width="fit-content"
                            >
                                { buttonCopy }
                            </Box>
                        </Link>
                    </Box>
                }
            </Flex>
        </Box>
    );
}

export default Snackbar;
